import { NavLink, Outlet } from 'react-router-dom';

import css from './Course.module.css';

function Course() {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to="/course/overview">{"<--"}</NavLink>
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/course/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default Course;